<template>
  <div v-if="shouldDisplayCookieConsent" class="cookie-consent">
    <div
      v-if="displayShortDescription"
      class="cookie-consent__short-description cookie-short-description"
    >
      {{ shortDescription }}
      <span class="cookie-short-description__expand-text" @click="showFullDescription">
        {{ $t('action.more') }}
      </span>
    </div>
    <i18n
      v-else
      path="cookieConsent.fullDescription"
      tag="div"
      class="cookie-consent__full-description"
    >
      <a
        class="link"
        :href="`https://www.skinxs.com/patient-notice/${$i18n.locale}`"
        target="_blank"
        >skinxs.com/patient-notice</a
      >
      <a class="link" :href="`https://www.skinxs.com/doctor-notice/${$i18n.locale}`" target="_blank"
        >skinxs.com/doctor-notice</a
      >
    </i18n>
    <app-button class="cookie-consent__confirm-button" inverted @click="updateAcceptCookies">
      {{ $t('action.okayGotIt') }}
    </app-button>
  </div>
</template>

<script>
import { pathOr } from 'ramda';

import { mapState } from 'vuex';

import AppButton from '@/components/common/AppButton.vue';

import LocalStorageService from '@/services/LocalStorageService';

import { types } from '@/store/types';
import { LOCALE } from '@/constants/locale';

const SHORT_DESCRIPTION_LENGTH = {
  [LOCALE.EN]: 161,
  [LOCALE.FR]: 178,
  [LOCALE.ES]: 173,
  [LOCALE.PT]: 188,
  [LOCALE.PL]: 170,
  [LOCALE.DE]: 165
};

const DEFAULT_SHORT_DESCRIPTION_LENGTH = 160;

export default {
  name: 'CookieConsent',
  components: { AppButton },
  data() {
    return {
      displayShortDescription: true,
      displayCookieConsent: true
    };
  },
  computed: {
    ...mapState({
      locale: types.state.LOCALE
    }),
    acceptCookies() {
      return LocalStorageService.getAcceptCookiesConsent();
    },
    shouldDisplayCookieConsent() {
      return !this.acceptCookies && this.displayCookieConsent;
    },
    shortDescription() {
      const text = this.$t('cookieConsent.fullDescription');
      const length = pathOr(
        DEFAULT_SHORT_DESCRIPTION_LENGTH,
        [this.locale],
        SHORT_DESCRIPTION_LENGTH
      );
      return text.slice(0, length);
    }
  },
  methods: {
    showFullDescription() {
      this.displayShortDescription = false;
    },
    updateAcceptCookies() {
      LocalStorageService.setAcceptCookiesConsent(true);
      this.displayCookieConsent = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors';

.cookie-consent {
  position: fixed;
  bottom: 27px;
  padding: 20px;
  max-width: 840px;
  margin-inline-start: 20px;
  background: $white-color;
  border-radius: 2px;

  &:not(:lang(ar)) {
    right: 20px;
  }

  &:lang(ar) {
    left: 20px;
  }

  &__short-description,
  &__full-description {
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: $tuatara-color;
  }

  &__short-description {
    max-width: 350px;
  }

  &__confirm-button {
    display: block;
    margin-top: 20px;
    margin-inline-start: auto;
    border: 1px solid $westar-color;
  }
}

.cookie-short-description {
  &__expand-text {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
    text-transform: uppercase;
  }
}
</style>
